import { connect } from 'react-redux';
import { DESKTOP, USER_DEVICE_MANIPULATOR_TYPE } from '@/constants';
import { handleZoomSliderChange, setFloatableInputVisible, handleSectionClick } from '@/actions';
import SchemasRenderingArea from './SchemasRenderingArea.jsx';

const mapStateToProps = state => {
  return {
    isUserDeviceManipulatorTypeMouse: state.core.userDeviceManipulatorType === USER_DEVICE_MANIPULATOR_TYPE.MOUSE,
    isSectionsSelected: Object.keys(state.core.sectionsSelection).length > 0,
    isDesktop: state.core.targetDevice === DESKTOP,
    scaleCoef: state.core.scaleCoef,
    targetDevice: state.core.targetDevice,
    floatableInputVisible: state.core.floatableInputVisible,
    pages: state.core.pages,
    fullscreenMode: state.cmmeReducer.fullscreenMode,
  };
};

const mapDispatchToProps = dispatch => ({
  handleZoomSliderChange: value => dispatch(handleZoomSliderChange(value)),
  setFloatableInputVisible: value => dispatch(setFloatableInputVisible(value)),
  handleSectionClick: value => dispatch(handleSectionClick(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SchemasRenderingArea);
